import { Injectable } from '@angular/core';
import { BaseFeatureRegistrationService } from '../../../services';

@Injectable({
  providedIn: 'root',
})
export class AttributeListFeatureRegistrationService extends BaseFeatureRegistrationService {}
